
import React from "react";
import { Activity } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { advancedTierSchema } from "@/contexts/program-creation/types";

interface TrackingRecoverySectionProps {
  form: UseFormReturn<z.infer<typeof advancedTierSchema>>;
}

export default function TrackingRecoverySection({ form }: TrackingRecoverySectionProps) {
  return (
    <div className="space-y-5 mb-8">
      <div className="flex items-center gap-2 text-white/90 border-b border-white/20 pb-2">
        <Activity size={18} />
        <h4 className="font-medium">Tracking</h4>
      </div>
      
      <FormField
        control={form.control}
        name="performanceTracking"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              How do they track their workouts and progress?
            </FormLabel>
            <Select 
              value={field.value} 
              onValueChange={field.onChange}
              defaultValue="app"
            >
              <FormControl>
                <SelectTrigger className="bg-white/20 border-white/30 text-white w-full h-12">
                  <SelectValue />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="app">Training app</SelectItem>
                <SelectItem value="spreadsheet">Spreadsheet/notebook</SelectItem>
                <SelectItem value="coach">Rely on coach feedback</SelectItem>
                <SelectItem value="dont_track">Don't track formally</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
